<template>
  <div v-if="activeClient" class="info">
    <div class="container">
      <span
        @click="changeReferralOpen"
        class="info__back"
        :class="{ 'locale-usa': locale === 'USA' }"
      >
        <img :src="getPic(locale)" alt="icon" />
        {{ $t('info_for_manager.clients_list') }}
      </span>
      <div class="info__data">
        <div class="info__data-client-info">
          <div class="info__data-client-info-title">Вы в аккаунте агента с ID {{ user.id }}</div>
          <div v-if="userEmail" class="info__data-client-info-date">Email: {{ userEmail }}</div>
          <div class="info__data-client-info-date" v-if="agent && agent.created_at">
            {{ $t('info_for_manager.registered') }} {{ fixDateFormat(agent.created_at) }}
          </div>
        </div>
        <div v-if="activeClient.is_legal" class="info__data-item">
          <div class="info__data-item-title">
            {{ $t('info_for_manager.company_name') }}
          </div>
          <div class="info__data-item-value">
            {{ activeClient.legal_name ? activeClient.legal_name : '' }}
          </div>
        </div>
        <div class="info__data-item">
          <div class="info__data-item-title">{{ $t('info_for_manager.contact_person') }} / ФИО</div>
          <div v-if="agent?.fio" class="info__data-item-value">
            {{ agent.fio }}
          </div>
          <div v-if="agent?.inn" class="info__data-item-value">ИНН: {{ agent.inn }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fixDateFormat from '@/mixin/fixDate';
import axios from 'axios';
import { setReactiveLocalStorage } from '@/utils/localStorage';
export default {
  name: 'InfoAboutAgent',
  mixins: [fixDateFormat],
  data() {
    return {
      locale: process.env.VUE_APP_LOCALE,
    };
  },
  computed: {
    activeClient() {
      return this.$store.state.Auth.activeAccount;
    },
    userEmail() {
      return this.$store.state.Auth.activeAccount.email;
    },
    user() {
      return this.$store.state.Auth.user;
    },
    agent() {
      return this.$store.state.Auth.user.agent;
    },
  },
  methods: {
    changeReferralOpen() {
      setReactiveLocalStorage('isOpenReferral', false);

      this.$store.commit('Auth/setData', {
        label: 'user',
        data: {
          ...this.user,
          // Очищаем здесь агента, потому что в BaseLayout мы проставили его от пользователя бизнес аккаунта, чтобы не сломать логику
          agent: null,
        },
      });
      this.$router.push({ name: 'Clients' });
    },
    getPic(locale) {
      if (locale === 'RU') {
        return require('@/assets/icons/icon-arrow-blue.svg');
      } else {
        return require('@/assets/icons/icon-arrow-red.svg');
      }
    },
  },

  async mounted() {
    if (JSON.parse(localStorage.getItem('isOpenReferral')) && !this.agent) {
      this.$store
        .dispatch('Auth/authAsAgent', {
          id: localStorage.getItem('active_client'),
          token: localStorage.getItem('token'),
        })
        .then((resp) => {
          this.$store.commit('Auth/setData', {
            label: 'user',
            data: {
              ...this.user,
              agent: resp.data.data.user.agent,
            },
          });

          this.$store.commit('Auth/setData', {
            label: 'activeAccount',
            data: resp.data.data.user,
          });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.data.client_token;
        });
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.info {
  margin-top: 4.7rem;

  &__back {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: bold;
    font-size: 2rem;
    line-height: 2.3rem;
    color: var(--primary);
    cursor: pointer;

    &.locale-usa {
      font-family: 'Gilroy';
      font-style: normal;
    }

    img {
      margin-right: 1.2rem;
      transform: rotate(90deg);
      display: block;
    }
  }

  &__data {
    background: #fff0c2;
    border-radius: 0.6rem;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 2rem 2.4rem 3rem;
    margin-top: 1.5rem;

    &-client-info {
      margin-right: 6rem;

      &-title {
        font-weight: 700;
        font-size: 2rem;
        line-height: 2.3rem;
        margin-bottom: 3px;
      }

      &-date {
        font-size: 1.4rem;
        line-height: 1.6rem;
        color: #7f858d;
      }
    }

    &-item {
      font-size: 1.4rem;
      line-height: 1.6rem;
      margin-right: 3rem;

      &:last-of-type {
        margin-right: 0;
      }

      &-title {
        color: #7f858d;
        margin-bottom: 5px;
        white-space: nowrap;
      }

      &-vvalue {
        color: #333333;
      }
    }
  }
}

@include below(993px) {
  .info__data {
    flex-direction: column;
    padding: 15px;
    > div {
      margin-right: 0;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
